import { Moment } from 'moment';
import moment from 'moment-timezone';
import { dateUtils } from '@bringg-frontend/utils';
import { RRule } from 'rrule';
import { Team as TeamType } from '@bringg/types/types/teams';

import { makeRRuleString } from 'bringg-web/services/rrule/rrule-service';

const buildSchedulesToCreate = (
	teamsMap: Map<number, TeamType>,
	timezone: string,
	templateStartTime: string,
	templateEndTime: string,
	teamIds?: number[],
	editStartDate?: string,
	editEndDate?: string,
	originalCapacity?: number,
	ical?: string
) => {
	const schedules = [];
	let until: Moment;
	teamIds.forEach(teamId => {
		const team = teamsMap.get(teamId);
		const timezoneOffset =
			moment()
				.tz(team.time_zone || timezone)
				.utcOffset() / 60;
		const shouldAddDay = timezoneOffset < 0;

		const deliveryBlockStartTime = dateUtils.getTimeInSelectedDate(templateStartTime, editStartDate).toISOString();

		const deliveryBlockEndTime = dateUtils.getTimeInSelectedDate(templateEndTime, editStartDate).toISOString();

		const options = RRule.fromString(ical).origOptions;

		let updateIcalOptions = { ...options };

		if (editEndDate) {
			until = dateUtils.getTimeInSelectedDate(templateStartTime, editEndDate);

			updateIcalOptions = {
				...options,
				until: until
					.clone()
					.add(shouldAddDay ? 1 : 0, 'd')
					.toDate()
			};
		}

		const newIcal = makeRRuleString(updateIcalOptions);

		const schedule = {
			team_id: teamId,
			end_time: deliveryBlockEndTime,
			start_time: deliveryBlockStartTime,
			termination_time: editEndDate ? until.toISOString() : '',
			original_capacity: originalCapacity,
			ical: newIcal
		};

		schedules.push(schedule);
	});

	return schedules;
};

export const deliveryBlockScheduleBuilder = { buildSchedulesToCreate };
